import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Banner } from '../../interfaces/Banner/Banner';
import { ComponentStyle } from '../../interfaces/Settings/SettingsV2/ComponentStyle';

type BannerContainerProps = {
  banner: Banner;
  maxHeight?: number;
  styleOverride?: ComponentStyle;
};

export const BannerContainer = ({
  banner,
  maxHeight,
  styleOverride,
}: BannerContainerProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden', // clip the image when it scales
        position: 'relative',
      }}
      onClick={banner.linkUrl ? () => navigate(banner.linkUrl) : undefined}
    >
      <Box
        component='img'
        src={banner.image}
        alt={banner.title}
        sx={{
          width: '100%',
          height: 'auto',
          maxHeight,
          cursor: banner.linkUrl ? 'pointer' : undefined,
          transition: 'transform 0.5s',
          display: 'block', // remove bottom spacing from inline img
          '&:hover': {
            transform: 'scale(1.1)',
          },
          ...styleOverride,
        }}
      />
    </Box>
  );
};
